import { IoMdClose } from "react-icons/io";
import { Button, Card, CardBody, Col, Label, Modal, ModalBody, Table, ModalHeader, Row, ModalFooter } from "reactstrap";
import { additionalSvg, customRound, proSvg } from "../constants/constant";
import { getRequest, getRequestForDownload, postRequest } from "../../../../hooks/axiosClient";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import '../../BuildProject.css';
import { useEffect, useRef, useState } from "react";
import CommonDropdown from "../../../../components/common/CommonDropdown";
import jsPDF from "jspdf";
import { BiCheck, BiCode, BiCopy } from "react-icons/bi";
import { useParams } from "react-router-dom";
import { decode } from "../../../../helpers/utils";
import { useSelector } from "react-redux";
import { environmentaldatas } from "../../../../constant/defaultValues";  
import { LuCode2 } from 'react-icons/lu';
import { IoPricetagOutline } from "react-icons/io5";
import { number } from "yup";
 

const ProPinModal = ({
    isOpen,
    toggle,
    totalPinsUsed,
    planDetails,
    addCardDetails,
    projectSettings
}) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} size='sm' zIndex={2001} style={{ zIndex: '999999 !important', color: '#000' }} centered>
            <ModalHeader style={{ padding: '25px 25px 15px 25px', fontSize: '1.5rem' }}>
                <div className='d-flex justify-space-between'>
                    <span>
                        You've Hit Your Limit!
                    </span>
                    <div className='ml-2  rounded-circle payment-close-btn' onClick={() => toggle()} >
                        <IoMdClose fontSize={15} />
                    </div>
                </div>
            </ModalHeader>
            <ModalBody style={{ padding: '0px 32px 32px 32px', fontSize: '0.875rem', fontWeight: '500' }}>
                <Card >
                    <p>You've reached the maximum number of pins for your current plan:</p>
                    <ul className='ulStyles' style={{ marginTop: '10px' }}>
                        <li>
                            <span className={`${totalPinsUsed?.used_locations == totalPinsUsed?.total_locations ? 'red' : ''}`}>{totalPinsUsed?.used_locations}</span>/{totalPinsUsed?.total_locations} Location Pins
                        </li>
                        <li>
                            <span className={`${totalPinsUsed?.used_products == totalPinsUsed?.total_products ? 'red' : ''}`}>{totalPinsUsed?.used_products}</span>/{totalPinsUsed?.total_products} Product Pins
                        </li>
                    </ul>
                    <p style={{ marginTop: '10px' }}>
                        {((planDetails?.plan?.free_expired == 1) && (planDetails?.plan?.basic_expired == 0) && (planDetails?.plan?.additional_expired == 0)) ? 'Please upgrade your plan to increase your total pin limit.' : 'Please purchase additional pins to increase your total pin limit.'}
                    </p>

                    <Card className="cardContainer">

                        <CardBody className='greycard'>
                            <div className="svgContainer">
                                {((planDetails?.plan?.free_expired == 1) && (planDetails?.plan?.basic_expired == 0) && (planDetails?.plan?.additional_expired == 0)) ? proSvg : additionalSvg}

                            </div>
                            <h1 style={{ fontSize: '1.5rem', fontWeight: '600' }}>{(planDetails?.plan?.free_expired == 1 && planDetails?.plan?.basic_expired == 0 && planDetails?.plan?.additional_expired == 0) ? 'Pro' : (planDetails?.plan?.free_expired == 1 && planDetails?.plan?.basic_expired == 1 && planDetails?.plan?.additional_expired == 0) ? 'Additional' : 'Additional +'}</h1>
                            <ul className='ulStyles'>
                                <li>
                                  {console.log(planDetails)}
                                    {
                                        (planDetails?.plan?.free_expired == 1 && planDetails?.plan?.basic_expired == 0 && planDetails?.plan?.additional_expired == 0)
                                            ?
                                            `$${customRound(((planDetails?.plan?.basic_cost) - ((planDetails?.plan?.basic_cost) * (planDetails?.plan?.discount / 100))), 2)}`
                                            :
                                            `$${customRound(((planDetails?.plan?.additional_cost) - ((planDetails?.plan?.additional_cost) * (planDetails?.plan?.discount / 100))), 2)}`} / month
                                </li>
                                <li>
                                    {(planDetails?.plan?.free_expired == 1 && planDetails?.plan?.basic_expired == 0 && planDetails?.plan?.additional_expired == 0) ? `${planDetails?.plan?.basic_location_pins}` : `${planDetails?.plan?.additional_location_pins}`}   Additional Location Pins
                                </li>
                                <li>
                                    {(planDetails?.plan?.free_expired == 1 && planDetails?.plan?.basic_expired == 0 && planDetails?.plan?.additional_expired == 0) ? `${planDetails?.plan?.basic_product_pins}` : `${planDetails?.plan?.additional_product_pins}`}  Additional Product Pins
                                </li>
                            </ul>
                        </CardBody>
                        <Button className={` ${(planDetails?.plan?.free_expired == 1) && (planDetails?.plan?.basic_expired == 0) && (planDetails?.plan?.additional_expired == 0) ? 'btn-warning ' : 'btn-successs'}`}
                            onClick={() => {
                                if ((planDetails?.plan?.free_expired == 1) && (planDetails?.plan?.basic_expired == 0) && (planDetails?.plan?.additional_expired == 0) && projectSettings?.status == 0) {
                                    toast.warning('Project is inactive! To upgrade to the pro plan, please activate your project.')
                                } else {
                                    addCardDetails(planDetails?.plan)
                                }
                            }
                            }
                        >
                            Proceed to Payment
                        </Button>
                    </Card>
                </Card >
            </ModalBody>
        </Modal>
    )
}

const GenerateQrModal = ({
    isOpen,
    toggle,
    projectSettings,
    filteredData,
}) => {
    const [loading, setLoading] = useState(false);
    const [beaconOptions, setBeaconOptions] = useState([]);
    const [beaconValue, setBeaconValue] = useState({});
    const canvasRef = useRef(null);

    const onChangeBeacon = (e) => {
        setBeaconValue(e) 
    }

    useEffect(() => {
        if (isOpen == true) {
            setBeaconValue({})
            // console.log(filteredData, 'filteredData')
            const sortedData = filteredData.filter(item => item.position !== null);
            setBeaconOptions((prev) => {
                return sortedData.map((el) => ({ ...el, value: el.enc_id, label: el.beacon_name }))
            });
        }
    }, [isOpen])

    const generateQrcode = async (row, type) => {
        setLoading(true);
        try {
            DownloadPdf(row,type)
            // const response = await getRequestForDownload(`generate-qr/${row?.enc_id}/${type}`);
            // console.log(response)
            // const dataRes = response.data;
            // const blob = new Blob([dataRes], {
            //     type: "application/pdf",
            // });
            // const url = window.URL.createObjectURL(blob);
            // const link = document.createElement("a");
            // link.href = url;
            // const pdfName = row?.beacon_name
            // link.setAttribute("download", `${pdfName}.pdf`);
            // document.body.appendChild(link);
            // link.click();
            // document.body.removeChild(link);
            // window.URL.revokeObjectURL(url);
            // toast.success('QR Code beacon poster generated successfully.');
            // createNotification('success', 'Student pin details downloaded successfully.', 'filled');
        } catch (error) {
            console.log(error)
            if (error.response.status === 400) {
                toast.error("Please publish the project to generate QR Code Beacon.")
            }
            setLoading(false)
        }
        // finally {
        //     setTimeout(() => {
        //         setLoading(false)
        //     }, 3000);
        // }
    }

    const deleteQrPng = async (imageUrl) => {
        try {
          const response = await postRequest(`delete-qr`,{url:imageUrl});
        //   console.log(response);
        } catch (error) {
          console.log(error);
        }
      }

    const DownloadQrcodeAsPng = async (row) => {
    setLoading(true);
        try {
        const response = await getRequest(`download-qr/${row?.enc_id}`);
        // console.log(response);
        const dataRes = response.data;
        downloadQrPng(dataRes, row)
        } catch (error) {
        // console.log(error);
        if (error.response.status === 400) {
            toast.error("Please publish the project to generate QR Code Beacon.")
        }
        } finally {
        setTimeout(() => {
            setLoading(false)
        }, 3000);
        }
    }

    const downloadQrPng = async (responseData, row) => {
        try {
            const imageUrl = responseData?.url;
            if (!imageUrl) {
                toast.error("Image URL not found.");
                return;
            }
    
            const imageResponse = await fetch(imageUrl);
            const blob = await imageResponse.blob();
    
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            const imageName = row?.beacon_name || "QRCode"; 
            link.setAttribute("download", `${imageName}.png`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
    
            toast.success("QR Code image downloaded successfully.");
            deleteQrPng(imageUrl)

        } catch (error) {
            console.error("Error downloading the QR Code:", error);
            toast.error("Failed to download QR Code.");
        }
    }; 
    
    const DownloadPdf = async (row, type) => {
        const pdfSizes = {
            1: { width: 595, height: 842, format: 'a4' },
            2: { width: 842, height: 1191, format: 'a3' },
            3: { width: 1684, height: 2382, format: [1684, 2382] }
        };
        const a4Size = pdfSizes[1];
        const targetSize = pdfSizes[type];

        try {
            const url = `generate-qr/${row?.enc_id}`;
            const response = await getRequest(url);
            const data = response?.data?.data;

            const beacon_template = JSON.parse(data?.beacon_template);
            const beacon_name = data?.beacon_name;
            const new_qr = data?.qrcodePath;

            if (!beacon_template || typeof beacon_template !== 'object') {
                console.error("Invalid or missing beacon_template:", beacon_template);
                return;
            }

            const canvasElement = canvasRef.current;
            if (!canvasElement) {
                console.error("Canvas ref not found.");
                return;
            }

            const canvas = new fabric.Canvas(canvasElement, {
                width: a4Size.width,
                height: a4Size.height,
                backgroundColor: '#ffffff',
            });

            fabric.Image.fromURL(new_qr, (newImg) => {
                // canvas.loadFromJSON(beacon_template, () => {
                //     canvas.renderAll();

                //     removeTaintedGroups(canvas);

                //     canvas.getObjects().forEach((obj) => {

                //         if (obj.name === "qr_container" && obj.type === "group") {
                //             const groupObjects = obj.getObjects();
                //             const oldQrImage = groupObjects.find(
                //                 (child) => child.name === "qrimage" && child.type === "image"
                //             );

                //             if (oldQrImage) {
                //                 const renderedWidth = oldQrImage.width * oldQrImage.scaleX;
                //                 const renderedHeight = oldQrImage.height * oldQrImage.scaleY;

                //                 const newScaleX = renderedWidth / newImg.width;
                //                 const newScaleY = renderedHeight / newImg.height;

                //                 newImg.set({
                //                     left: oldQrImage.left,
                //                     top: oldQrImage.top,
                //                     scaleX: newScaleX,   
                //                     scaleY: newScaleY,
                //                     angle: oldQrImage.angle,
                //                     originX: oldQrImage.originX,
                //                     originY: oldQrImage.originY,
                //                     name: oldQrImage.name,
                //                     selectable: oldQrImage.selectable,
                //                 });

                //                 obj.remove(oldQrImage);
                //                 obj.add(newImg);
                //                 obj.addWithUpdate();
                //             }
                //         }

                //         if (obj.name === "qr_container" && obj.type === "textbox") {
                //             const originalCenter = obj.getCenterPoint();
                //             obj.text = applyMatchingCase(obj.text, beacon_name);
                //             obj.set({
                //                 originX: 'center',
                //                 originY: 'center',
                //                 left: originalCenter.x,
                //                 top: originalCenter.y,
                //             });
                //         }

                //         if (obj.objectLayoutType === "layout-boundary" && obj.type === "group") {
                //             obj.set({
                //                 shadow: null,
                //                 stroke: null,
                //                 strokeWidth: 0,
                //                 padding: 0, 
                //                 borderScaleFactor: 0
                //             });
                //         }
                //     });

                //     canvas.renderAll();

                //     const backgroundObject = canvas.getObjects().find(
                //         (obj) => obj.objectLayoutType === "layout-boundary" && obj.type === "group"
                //     );

                //     if (!backgroundObject) {
                //         console.error("❌ No layout-boundary group found.");
                //         return;
                //     }

                //     backgroundObject.setCoords();
                //     canvas.renderAll();

                //     const bounds = backgroundObject.getBoundingRect(true, true);

                //     const objectsInside = canvas.getObjects().filter((obj) => {
                //         if (obj === backgroundObject) return true;
                //         const objBounds = obj.getBoundingRect();
                //         return !(
                //             objBounds.left + objBounds.width < bounds.left ||
                //             objBounds.left > bounds.left + bounds.width ||
                //             objBounds.top + objBounds.height < bounds.top ||
                //             objBounds.top > bounds.top + bounds.height
                //         );
                //     });

                //     const tempCanvas = new fabric.StaticCanvas(null, {
                //         width: bounds.width,
                //         height: bounds.height,
                //         backgroundColor: '#ffffff',
                //     });

                //     let cloneCount = 0;
                //     const total = objectsInside.length;
  
                //     objectsInside.forEach((obj) => {
                //         obj.clone((cloned) => {
                //             cloned.set({
                //                 left: cloned.left - bounds.left,
                //                 top: cloned.top - bounds.top,
                //             });
                            
                //             if (obj.objectLayoutType === "layout-boundary") {
                //                 tempCanvas.insertAt(cloned, 0);  
                //             } else {
                //                 tempCanvas.add(cloned);  
                //             }

                //             cloneCount++;

                //             if (cloneCount === total) {
                //                 tempCanvas.renderAll();
                //                 const scaleX = targetSize.width / a4Size.width;
                //                 const scaleY = targetSize.height / a4Size.height;
                //                 const scale = Math.min(scaleX, scaleY);
                //                 exportCanvasAsPNG(tempCanvas, beacon_name, targetSize, scale);
                //             }
                //         });
                //     });
                // });
            
                canvas.loadFromJSON(beacon_template, () => {
                    canvas.renderAll();
 
                    const layoutBoundary = canvas.getObjects().find(
                        (obj) => obj.objectLayoutType === "layout-boundary"
                    );

                    if (!layoutBoundary) {
                        console.error("❌ No layout-boundary found.");
                        return;
                    }

                    // removeTaintedGroups(canvas);
                    console.log(layoutBoundary.type);

                    if (layoutBoundary.type === "group" || layoutBoundary.type === "rect") {
                        handleNewTemplate(newImg, canvas, beacon_name, layoutBoundary, targetSize, a4Size);
                    } else {
                        handleOldTemplate(newImg, canvas, beacon_name, layoutBoundary, targetSize, a4Size);
                    }
                });
            
            }, { crossOrigin: 'anonymous' });

        } catch (error) {
            console.error("QR fetch error:", error);
            toast.error(error?.response?.data?.message || 'Something went wrong.')
        }
    };

    const processExport = (bounds, canvas, layoutBoundary, beacon_name, targetSize, a4Size) => {
        const objectsInside = canvas.getObjects().filter((obj) => {
        if (obj === layoutBoundary) return true;

        const objBounds = obj.getBoundingRect();
            return !(
                objBounds.left + objBounds.width < bounds.left ||
                objBounds.left > bounds.left + bounds.width ||
                objBounds.top + objBounds.height < bounds.top ||
                objBounds.top > bounds.top + bounds.height
            );
        });

        const tempCanvas = new fabric.StaticCanvas(null, {
            width: bounds.width,
            height: bounds.height,
            backgroundColor: "#ffffff"
        });

        let cloneCount = 0;
        const total = objectsInside.length;

        objectsInside.forEach((obj) => {
            obj.clone((cloned) => {
                cloned.set({
                    left: cloned.left - bounds.left,
                    top: cloned.top - bounds.top
                });

                if (obj.objectLayoutType === "layout-boundary") {
                    tempCanvas.insertAt(cloned, 0);
                } else {
                    tempCanvas.add(cloned);
                }

                cloneCount++;

                if (cloneCount === total) {
                    tempCanvas.renderAll();

                    const scaleX = targetSize.width / a4Size.width;
                    const scaleY = targetSize.height / a4Size.height;
                    const scale = Math.min(scaleX, scaleY);

                    exportCanvasAsPNG(tempCanvas, beacon_name, targetSize, scale);
                }
            });
        });
    };

    // const handleNewTemplate = (newImg, canvas, beacon_name, layoutBoundary, targetSize, a4Size) => {
    //     canvas.getObjects().forEach((obj) => {
    //         if (obj.name === "qr_container" && obj.type === "group") {
    //             const oldQrImage = obj.getObjects().find(
    //             (child) => child.name === "qrimage" && child.type === "image"
    //             );

    //             if (oldQrImage) {
    //                 const renderedWidth = oldQrImage.width * oldQrImage.scaleX;
    //                 const renderedHeight = oldQrImage.height * oldQrImage.scaleY;

    //                 newImg.set({
    //                     left: oldQrImage.left,
    //                     top: oldQrImage.top,
    //                     scaleX: renderedWidth / newImg.width,
    //                     scaleY: renderedHeight / newImg.height,
    //                     angle: oldQrImage.angle,
    //                     originX: oldQrImage.originX,
    //                     originY: oldQrImage.originY,
    //                     name: oldQrImage.name,
    //                     selectable: oldQrImage.selectable
    //                 });

    //                 obj.remove(oldQrImage);
    //                 obj.add(newImg);
    //                 obj.addWithUpdate();
    //             }
    //         }

    //         if (obj.name === "qr_container" && obj.type === "textbox") {
    //             const originalCenter = obj.getCenterPoint();

    //             obj.text = applyMatchingCase(obj.text, beacon_name);
    //             obj.set({
    //                 originX: "center",
    //                 originY: "center",
    //                 left: originalCenter.x,
    //                 top: originalCenter.y
    //             });
    //         }

    //         if (obj.objectLayoutType === "layout-boundary" && obj.type === "group") {
    //             obj.set({
    //                 shadow: null,
    //                 stroke: null,
    //                 strokeWidth: 0,
    //                 padding: 0,
    //                 borderScaleFactor: 0
    //             });
    //         }
    //     });

    //     layoutBoundary.setCoords();
    //     const bounds = layoutBoundary.getBoundingRect(true, true);

    //     processExport(bounds, canvas, layoutBoundary, beacon_name, targetSize, a4Size);
    // };

    const handleNewTemplate = (newImg, canvas, beacon_name, layoutBoundary, targetSize, a4Size) => {  

      console.log({newImg,beacon_name,layoutBoundary});

        const replaceCompanyLogo = (logoObj, parentGroup = null) => { 
            return new Promise((resolve) => {
                fabric.Image.fromURL(projectSettings?.logo, (logoImg) => {
                    const renderedWidth = logoObj.width * logoObj.scaleX;
                    const renderedHeight = logoObj.height * logoObj.scaleY;

                    logoImg.set({
                        left: logoObj.left,
                        top: logoObj.top,
                        scaleX: renderedWidth / logoImg.width,
                        scaleY: renderedHeight / logoImg.height,
                        angle: logoObj.angle,
                        originX: logoObj.originX,
                        originY: logoObj.originY,
                        name: logoObj.name,
                        selectable: logoObj.selectable,
                    });

                    if (parentGroup) {
                        parentGroup.remove(logoObj);
                        parentGroup.add(logoImg);
                        parentGroup.addWithUpdate();
                    } else {
                        canvas.remove(logoObj);
                        canvas.add(logoImg);
                    }

                    canvas.renderAll();
                    resolve(); 
                }, { crossOrigin: 'anonymous' });
            });
        };
 
        const logoReplacePromises = [];

        canvas.getObjects().forEach((obj) => { 
            if (obj.name === "qr_container" && obj.type === "group") {
                const oldQrImage = obj.getObjects().find(
                    (child) => child.name === "qrimage" && child.type === "image"
                );

                if (oldQrImage) {
                    const renderedWidth = oldQrImage.width * oldQrImage.scaleX;
                    const renderedHeight = oldQrImage.height * oldQrImage.scaleY;

                    newImg.set({
                        left: oldQrImage.left,
                        top: oldQrImage.top,
                        scaleX: renderedWidth / newImg.width,
                        scaleY: renderedHeight / newImg.height,
                        angle: oldQrImage.angle,
                        originX: oldQrImage.originX,
                        originY: oldQrImage.originY,
                        name: oldQrImage.name,
                        selectable: oldQrImage.selectable
                    });

                    obj.remove(oldQrImage);
                    obj.add(newImg);
                    obj.addWithUpdate();
                }
            }

            if (obj.name === "company-log" && obj.type === "image") { 
                logoReplacePromises.push(replaceCompanyLogo(obj, null));
            }

            if (obj.name === "qr_container" && obj.type === "textbox") {
                const originalCenter = obj.getCenterPoint();
                obj.text = applyMatchingCase(obj.text, beacon_name);
                obj.set({
                    originX: "center",
                    originY: "center",
                    left: originalCenter.x,
                    top: originalCenter.y
                });
            }

            if (obj.objectLayoutType === "layout-boundary" && obj.type === "group") {
                obj.set({
                    shadow: null,
                    stroke: null,
                    strokeWidth: 0,
                    padding: 0,
                    borderScaleFactor: 0
                });
            }
        });
 
        Promise.all(logoReplacePromises).then(() => {
            layoutBoundary.setCoords();
            const bounds = layoutBoundary.getBoundingRect(true, true);
            processExport(bounds, canvas, layoutBoundary, beacon_name, targetSize, a4Size);
        });
    };

    const handleOldTemplate = (newImg, canvas, beacon_name, layoutBoundary, targetSize, a4Size) => { 
        canvas.getObjects().forEach((obj) => {
        if (obj.name === "qrimage" && obj.type === "image") {
            newImg.set({
            left: obj.left,
            top: obj.top,
            scaleX: obj.scaleX,
            scaleY: obj.scaleY,
            angle: obj.angle,
            originX: obj.originX,
            originY: obj.originY,
            name: obj.name,
            selectable: obj.selectable,
            zIndex: obj.zIndex
            });

            canvas.remove(obj);
            canvas.add(newImg);
        }

        if (obj.name === "qrimage" && obj.type === "textbox") {
            const originalCenter = obj.getCenterPoint();
            obj.text = applyMatchingCase(obj.text, beacon_name);

            obj.set({
            originX: "center",
            originY: "center",
            left: originalCenter.x,
            top: originalCenter.y
            });
        }

        if (obj.objectLayoutType === "layout-boundary") {
            obj.set({
                shadow: null,
                stroke: null,
                strokeWidth: 0,
                padding: 0,
                borderScaleFactor: 0
            });
        }
        });

        layoutBoundary.setCoords();
        const bounds = layoutBoundary.getBoundingRect();

        processExport(bounds, canvas, layoutBoundary, beacon_name, targetSize, a4Size);
    };

    const applyMatchingCase = (templateText, inputText) => {
        if (!templateText) return inputText;
    
        const isUpperCase = templateText === templateText.toUpperCase();
        const isLowerCase = templateText === templateText.toLowerCase();
        const isCapitalized = /^[A-Z][a-z]/.test(templateText);
    
        if (isUpperCase) {
          return inputText.toUpperCase();
        } else if (isLowerCase) {
          return inputText.toLowerCase();
        } else if (isCapitalized) {
          return inputText
            .toLowerCase()
            .replace(/\b\w/g, (c) => c.toUpperCase());
        }
    
        return inputText;
    };
    
    function exportCanvasAsPNG(canvas, name = 'beacon', size) {
        try {
            const multiplier = 3; 
            const dataURL = canvas.toDataURL({
                format: 'png',
                multiplier: multiplier,
                quality: 1,
            });
        
            const pdf = new jsPDF({
                // orientation: size.width > size.height ? 'landscape' : 'portrait',
                orientation: 'portrait',
                unit: 'pt',
                format: size.format
            });
        
            pdf.addImage(dataURL, 'PNG', 0, 0, size.width, size.height);
            pdf.save(`${name}-${size?.format}.pdf`);
            toast.success('QR Code beacon poster generated successfully.');
            setLoading(false);
        } catch (err) {
            console.error('Export failed:', err);
            toast.error("Export failed due to a tainted image.")
            // alert('Export failed due to a tainted image.');
            setLoading(false)
        }
    }
        
    function containsTaintedImage(obj) {
        if (obj.type === 'image') {
            const src = obj.getSrc?.();
            return src && !src.startsWith('data:image');
        }
        if (obj._objects) {
            return obj._objects.some(child => containsTaintedImage(child));
        }
        return false;
    }
    
    function removeTaintedGroups(canvas) {
        const objects = canvas.getObjects();
        for (let i = objects.length - 1; i >= 0; i--) {
            const obj = objects[i];
 
            if (obj.name === "qr_container" || obj.objectLayoutType === "layout-boundary") {
                continue;
            }

            if ((obj.type === 'group' || obj._objects) && containsTaintedImage(obj)) {
                // console.warn('Removing tainted group:', obj);
                // canvas.remove(obj);
            }
        }
        canvas.renderAll();
    }

    return (
        <>
            <Modal className="panel-header-canvas" isOpen={isOpen} zIndex={2001} toggle={toggle} style={{ zIndex: '999999 !important', maxWidth: '850px' }} centered>
                <canvas ref={canvasRef} style={{display:"none"}}/>
                <ModalHeader toggle={toggle} style={{ padding: '33px 32px 0px 32px' }} className="qr-downlaod-modal">
                    Generate QR Code Beacon Poster
                </ModalHeader>

                <ModalBody className="modalbody-padding" >
                    <Row className='mt-2 mb-3' >
                        <Col md={6}>

                            <Label className='form-labels'>Select QR Code Beacon</Label>
                            <CommonDropdown name='agent' options={beaconOptions} value={Object.keys(beaconValue).length > 0 ? beaconValue : null} onChange={(e) => { onChangeBeacon(e) }} />


                        </Col>
                    </Row>
                    {/* <Row >
                        <Col md={12}>
                            <div className="mb-2">
                                <Label style={{ color: '#6a6d73', fontSize: '0.875rem', fontWeight: 'bold', marginTop: '11.48px' }}>{projectSettings?.project_name}</Label>
                            </div>
                        </Col>
                    </Row> */}
                    <Row >
                        <Col md={12}>
                            <Table className="custom-table">
                                <thead>
                                    <tr>
                                        <th className='theadStyle'>Beacon</th>
                                        <th className='theadStyle'>Poster</th>
                                        {/* <th className='theadStyle'>Web</th> */}
                                        <th className='theadStyle'>QR Code</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {beaconValue?.beacon_name ? (
                                        // filteredData?.length > 0 ? (
                                        // filteredData?.map((item, index) => (
                                            <tr >
                                                <td>{beaconValue.beacon_name}</td>
                                                <td>
                                                    <div className='d-flex'>
                                                        <button className="btn btn-sm buttoninfo mr-2" onClick={() => generateQrcode(beaconValue, 1)}>A4</button>{" "}
                                                        <button className="btn btn-sm buttoninfo mr-2" onClick={() => generateQrcode(beaconValue, 2)}>A3</button>
                                                    </div>
                                                </td>
                                                {/* <td>
                                                    <button className="btn btn-sm buttoninfo" onClick={() => generateQrcode(beaconValue, 3)}>FHD</button>
                                                </td> */}
                                                <td>
                                                    <button className="btn btn-sm buttoninfo " onClick={() => DownloadQrcodeAsPng(beaconValue)}> Download</button>
                                                </td>
                                            </tr>
                                        // ))
                                    ) : (
                                        <tr>
                                            <td colSpan="3">No data found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>

                        </Col>
                    </Row>

{/* {console.log(beaconValue)} */}
                    {beaconValue?.beacon_name && !beaconValue?.qr_link && !beaconValue?.positions && (
                      <Row className="mt-2 mb-3">
                        <Col md={12}>
                          <div
                            className="d-flex align-items-start"
                            style={{
                              width: "100%",
                              background: "#fff3cd",
                              border: "1px solid #ffe69c",
                              borderRadius: "6px",
                              padding: "10px 12px",
                              color: "#856404",
                            }}
                          >

                            <div>
                              {/* <div style={{ fontWeight: 600 }}>Warning</div> */}
                              <div style={{ fontSize: "0.875rem" }}>
                                Place the beacon on the map and publish the project to generate its direct URL.                              
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}

                    {!beaconValue?.qr_link && beaconValue?.positions && (
                      <Row className="mt-2 mb-3">
                        <Col md={12}>
                          <div
                            className="d-flex align-items-start"
                            style={{
                              width: "100%",
                              background: "#fff3cd",
                              border: "1px solid #ffe69c",
                              borderRadius: "6px",
                              padding: "10px 12px",
                              color: "#856404",
                            }}
                          >

                            <div>
                              {/* <div style={{ fontWeight: 600 }}>Warning</div> */}
                              <div style={{ fontSize: "0.875rem" }}>
                                Publish the project to generate the direct URL for this beacon.
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    )}

                    {beaconValue?.qr_link && <Row className="mt-1 mb-3">
                        <Col md={12}>
                            <Label style={{ color: '#000', width:"100%", fontSize: '0.875rem',  marginBottom:"4px" }}>Direct link</Label>
                            <div className='input-group' style={{ padding: '0px ', border: 'none', maxWidth:"700px" }}>
                                <input type="text" className="form-control" placeholder="Enter project link" style={{fontWeight:500}} readOnly value={beaconValue?.qr_link} />
                                < div className='input-group-append' style={{height:'-webkit-fill-available'}}>
                                    <button className="btn btn-sm buttoninfo " style={{height:'100%'}} onClick={() => { navigator.clipboard.writeText(beaconValue?.qr_link ) }}><BiCopy /></button>
                                </div>
                            </div>
                        </Col>
                    </Row>}

                    <Row className="mt-3 mb-3">
                        <Col md={12}>
                            <Button color="secondary" className="btn btnCancel float-right" onClick={toggle}>
                                Cancel
                            </Button>
                        </Col>
                    </Row>

                </ModalBody>
                
            </Modal>
            {loading &&
                <Modal isOpen={true} size="sm" zIndex={2001} className="loading-modal" style={{ zIndex: '9999999 !important', maxWidth: '200px', backgroundColor: 'transparent' }} centered>
                    <ModalBody >
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>

                            <div class="folder">
                                <span class="folder-tab"></span>
                                <div class="folder-icn">
                                    <div class="downloading">
                                        <span class="custom-arrow"></span>
                                    </div>
                                    <div class="bar-downld"></div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            }
        </>

    )
}

const EmbedCodeBlock = ({ embedUrl }) => {
 
  const lines = [
    [['<iframe', 'tag']],
    [['  src', 'attr'], ['=', 'white'], ['"', 'val'], [embedUrl, 'val'], ['"', 'val']],
    [['  width', 'attr'], ['=', 'white'], ['"100%"', 'val']],
    [['  height', 'attr'], ['=', 'white'], ['"550"', 'val']],
    [['  style', 'attr'], ['=', 'white'], ['"border:0; overflow:auto;"', 'val']],
    [['  allow', 'attr'], ['=', 'white'], ['"fullscreen"', 'val']],
    [['  allowfullscreen', 'attr'], ['>', 'tag']],
    [['</iframe>', 'tag']],
  ];

  const colorMap = {
    tag:   '#4ec9b0', 
    attr:  '#9cdcfe', 
    val:   '#ce9178', 
    white: '#d4d4d4', 
  };

  return (
    <div style={{
      background: '#1e1e2e',
      borderRadius: '8px',
    //   padding: '16px 20px',
      position: 'relative',
      fontFamily: "'Fira Code', 'Cascadia Code', 'Consolas', monospace",
    }}>
 
      {/* <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '14px' }}>
        <LuCode2 style={{ color: '#a0a8c0', fontSize: '15px' }} />
        <span style={{ fontSize: '13px', fontWeight: 500, color: '#a0a8c0', letterSpacing: '0.03em' }}>
          HTML
        </span>
      </div> */}
 
      {/* <button
        onClick={handleCopy}
        title="Copy code"
        style={{
          position: 'absolute',
          top: '14px',
          right: '14px',
          background: 'transparent',
          border: '0.5px solid #444466',
          borderRadius: '6px',
          padding: '5px 7px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'border-color 0.15s',
        }}
      >
        {copied
          ? <BiCheck style={{ color: '#4ec9b0', fontSize: '16px' }} />
          : <BiCopy style={{ color: '#a0a8c0', fontSize: '16px' }} />
        }
      </button> */}
 
      <pre style={{ margin: 0, lineHeight: '1.75', fontSize: '13.5px', whiteSpace: 'pre', overflowX: 'auto' }}>
        {lines.map((tokens, li) => (
          <div key={li}>
            {tokens.map(([text, type], ti) => (
              <span key={ti} style={{ color: colorMap[type] ?? colorMap.white }}>
                {text}
              </span>
            ))}
          </div>
        ))}
      </pre>
    </div>
  );
}; 

const EmbedProjectModal = ({ isOpen, toggle, filteredData }) => {
    const floorLevels   = useSelector((state) => state.api.floorList);
    const { id }        = useParams();
    const projectId     = decode(id)

    const { mobile_base_url } = environmentaldatas

    const [selectedFloor, setSelectedFloor] = useState(floorLevels?.[0] || null);
    const [copied, setCopied]               = useState(false);
    const [dummyBeacon, setDummyBeacon]     = useState(null); 

    useEffect(() => {
        if (isOpen) setSelectedFloor(floorLevels?.[0] || null);
    }, [isOpen, floorLevels]);

    useEffect(() => {
        if (!isOpen) return;

        try {
            const sortedData = (filteredData || []).filter(
                item => item?.position !== null
            );

            if (!sortedData.length) {
                setDummyBeacon(null);
                return;
            }

            const qrLink = sortedData?.[0]?.qr_link;

            if (!qrLink || typeof qrLink !== "string") {
                setDummyBeacon(null);
                return;
            }

            const qrPublishedId = qrLink
                .split("/")
                .filter(Boolean);

            const beaconId =
                qrPublishedId?.[qrPublishedId.length - 1] || null;

            setDummyBeacon(beaconId); 

        } catch (error) {
            console.error("Error extracting beacon ID:", error);
            setDummyBeacon(null);
        }
    }, [isOpen, filteredData]);

    // ${dummyBeacon}/
    const embedUrl = `${mobile_base_url}/center-information/${selectedFloor?.enc_id || '0'}`;

    const embedCode = `<iframe
            src="${embedUrl}"
            width="100%"
            height="550"
            style="border:0; overflow:auto;"
            allow="fullscreen"
            allowfullscreen>
        </iframe>`; 

    const handleCopy = () => {
        navigator.clipboard.writeText(embedCode).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        });
    }; 

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered style={{ maxWidth: '760px' }} zIndex={2001}>
            <ModalHeader style={{paddingBottom:"10px"}}>
                Embed project on website
            </ModalHeader>

            <ModalBody style={{ padding: '0px 28px' }}>
                <p className="form-labels mb-1">Select a starting floor plan</p>
                <div style={{maxWidth:"300px"}}>
                    <CommonDropdown
                        options={floorLevels?.map((f) => ({ ...f, value: f.enc_id, label: f.floor_plan }))}
                        value={selectedFloor ? { value: selectedFloor.enc_id, label: selectedFloor.floor_plan } : null}
                        onChange={(e) => setSelectedFloor(floorLevels.find((f) => f.enc_id === e.value))}
                    />
                </div>

                {
                  selectedFloor?.enc_id && <>
                    <p className="form-labels mt-4 mb-2">Copy the embed code for your website</p>
                    <div style={{ background: '#1e1e2e', borderRadius: '8px', padding: '16px', position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '10px' }}>
                            <BiCode style={{ color: '#a0a8c0', fontSize: '14px' }} />
                            <span style={{ fontSize: '12px', fontWeight: 500, color: '#a0a8c0' }}>HTML</span>
                        </div>
                        <button
                            onClick={handleCopy}
                            style={{ position: 'absolute', top: '14px', right: '14px', background: 'transparent', border: '0.5px solid #444466', borderRadius: '6px', padding: '5px 7px', cursor: 'pointer' }}
                        >
                            {copied ? <BiCheck style={{ color: '#4ec9b0', fontSize: '16px' }} /> : <BiCopy style={{ color: '#a0a8c0', fontSize: '16px' }} />}
                        </button>
                        {/* <pre style={{ fontFamily: 'monospace', fontSize: '13px', lineHeight: 1.7, color: '#cdd6f4', whiteSpace: 'pre', overflow: 'hidden' }}>
                            {embedCode} 
                        </pre> */}

                        <EmbedCodeBlock embedUrl={embedUrl} />
                    </div>
                  </>
                }
            </ModalBody>

            <ModalFooter>
                <Button color="secondary" className="btn btnCancel" onClick={toggle}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
}; 



const locationIconSvg = (color = "#26A3DB") => `
  <svg width="22" height="25" xmlns="http://www.w3.org/2000/svg" fill="none">
    <g>
      <title>Location</title>
      <path fill="${color}" d="m10,0c-5.53061,0 -10,4.32465 -10,9.67615c0,1.56005 0.42857,3.08055 1.08163,4.44315c0.46939,0.9873 1.55102,2.4684 1.81633,2.8238c1.53061,2.0142 7.10204,8.0569 7.10204,8.0569c0,0 5.5918,-6.0427 7.102,-8.0569c0.2653,-0.3554 1.347,-1.8167 1.8164,-2.8238c0.653,-1.3626 1.0816,-2.8831 1.0816,-4.44315c0,-5.3515 -4.4694,-9.67615 -10,-9.67615z"/>
      <path fill="white" d="m9.99998,17.7923c4.63242,0 8.38772,-3.6337 8.38772,-8.11613c0,-4.4824 -3.7553,-8.11611 -8.38772,-8.11611c-4.63242,0 -8.38775,3.63371 -8.38775,8.11611c0,4.48243 3.75533,8.11613 8.38775,8.11613z"/>
      <path fill="${color}" d="m10,16.331c3.7984,0 6.8776,-2.9795 6.8776,-6.65486c0,-3.67535 -3.0792,-6.65482 -6.8776,-6.65482c-3.79836,0 -6.87755,2.97947 -6.87755,6.65482c0,3.67536 3.07919,6.65486 6.87755,6.65486z"/>
      <path fill="white" d="m13.1429,7.80014c1.2623,0 2.2857,-0.99021 2.2857,-2.21169c0,-1.22148 -1.0234,-2.2117 -2.2857,-2.2117c-1.2624,0 -2.2858,0.99022 -2.2858,2.2117c0,1.22148 1.0234,2.21169 2.2858,2.21169z"/>
    </g>
  </svg>`;

const productIconSvg = (color = "#F2C538") => `
  <svg width="20" height="25" xmlns="http://www.w3.org/2000/svg" fill="none">
    <g>
      <title>Product</title>
      <path fill="${color}" d="m10,0c-5.52783,0 -10,4.32764 -10,9.67682c0,1.56018 0.42227,3.08318 1.07486,4.43908c0.47985,1.003 1.5547,2.4703 1.82341,2.8232c1.51632,2.0245 7.10173,8.0609 7.10173,8.0609c0,0 5.5854,-6.0364 7.1017,-8.0609c0.2687,-0.3529 1.3436,-1.8202 1.8234,-2.8232c0.6526,-1.3559 1.0749,-2.8789 1.0749,-4.43908c0,-5.34918 -4.4722,-9.67682 -10,-9.67682z"/>
      <path fill="white" d="m9.99999,17.7935c4.63241,0 8.38771,-3.634 8.38771,-8.11669c0,-4.48269 -3.7553,-8.11664 -8.38771,-8.11664c-4.63241,0 -8.38772,3.63395 -8.38772,8.11664c0,4.48269 3.75531,8.11669 8.38772,8.11669z"/>
      <path fill="${color}" d="m10,16.3262c3.795,0 6.8714,-2.9771 6.8714,-6.64938c0,-3.67232 -3.0764,-6.64933 -6.8714,-6.64933c-3.79497,0 -6.8714,2.97701 -6.8714,6.64933c0,3.67228 3.07643,6.64938 6.8714,6.64938z"/>
      <path fill="white" d="m10,11.9057c1.2721,0 2.3033,-0.9979 2.3033,-2.22888c0,-1.23094 -1.0312,-2.22882 -2.3033,-2.22882c-1.27206,0 -2.30327,0.99788 -2.30327,2.22882c0,1.23098 1.03121,2.22888 2.30327,2.22888z"/>
    </g>
  </svg>`; 

const SectionLabel = ({ children }) => (
  <p style={{
    fontSize: 12, fontWeight: 600, color: '#666',
    textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 10,
  }}>
    {children}
  </p>
);

const cardStyle = {
  background: '#f7f7f7', borderRadius: 10,
  border: '1px solid #d7d7d7',
  padding: '14px 16px',
  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
};

const UsageCard = ({ label, used, limit, color, over, pin }) => (
  <div style={{
    background: '#f7f7f7', borderRadius: 10,
    border: '1px solid #d7d7d7',
    padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 10,
  }}>
    <div dangerouslySetInnerHTML={{ __html: pin }} />
    <div>
      <div style={{ fontSize: 12, color: '#666', marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 18, fontWeight: 600 }}>
        <span style={{ color: over ? '#e53e3e' : color }}>{used}</span>
        <span style={{ fontSize: 14, fontWeight: 400, color: '#666' }}> / {limit}</span>
      </div>
    </div>
  </div>
);

const CapCard = ({ label, value, breakdown, color, pin }) => (
  <div style={{
    background: '#f7f7f7', borderRadius: 10,
    border: '1px solid #d7d7d7',
    padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 10,
  }}>
    <div dangerouslySetInnerHTML={{ __html: pin }} />
    <div>
      <div style={{ fontSize: 12, color: '#666', marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: 20, fontWeight: 700, color }}>{value}</div>
      <div style={{ fontSize: 11, color: '#666' }}>{breakdown}</div>
    </div>
  </div>
);

const Counter = ({ value, onChange, minValue = 0 }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <button
      onClick={() => onChange(value - 1)}
      disabled={value <= minValue}
      style={{
        width: 28, height: 28,
        border: '1px solid #ddd', borderRadius: '6px',
        background: value <= minValue ? '#f5f5f5' : '#fff',
        color: value <= minValue ? '#ccc' : '#000',
        cursor: value <= minValue ? 'not-allowed' : 'pointer',
        fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >−</button>
    <div style={{
      width: 32, height: 28,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: 14, fontWeight: 500,
    }}>
      {value}
    </div>
    <button
      onClick={() => onChange(value + 1)}
      style={{
        width: 28, height: 28,
        border: '1px solid #ddd', borderRadius: '6px',
        background: '#fff', cursor: 'pointer',
        fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >+</button>
  </div>
);

const CheckIcon = ({color = "#059669"}) => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="7" stroke={color} strokeWidth="1.2" />
    <path d="M5 8l2 2 4-4" stroke={color} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const LockIcon = ({ size = 14, color = '#fff' }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none">
    <rect x="3" y="7" width="10" height="8" rx="1.5" stroke={color} strokeWidth="1.4" />
    <path d="M5.5 7V5a2.5 2.5 0 015 0v2" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
  </svg>
);

const PublishUpgradeModal = ({
  isOpen,
  onContinueEditing,
  onUpgradeAndPublish,
  planName = 'Pro plan',
  isEditMode = false,
  pinCountOverride = null,
  cancelLabel = 'Continue editing',
}) => {
  const pinCountFromStore = useSelector((state) => state.api.pinCount);
  const pinCount    = pinCountOverride ?? pinCountFromStore;
  const projectData = useSelector((state) => state.api.projectData);

  const planDetails = isOpen?.plan || {};

  const FREE = { locPins: 1,  prodPins: 200, price: 0 };
  const PRO  = {
    locPins:  Number(planDetails.basic_location_pins)      || 0,
    prodPins: Number(planDetails.basic_product_pins)       || 0,
    price:    Number(planDetails.basic_cost)               || 0,
  };
  const PACK = {
    locPins:  Number(planDetails.additional_location_pins) || 0,
    prodPins: Number(planDetails.additional_product_pins)  || 0,
    price:    Number(planDetails.additional_cost)          || 0,
  };

  const currentLocPins  = pinCount?.used_locations ?? 0;
  const currentProdPins = pinCount?.used_products  ?? 0;
  const totalLocPins    = pinCount?.total_locations ?? FREE.locPins;
  const totalProdPins   = pinCount?.total_products  ?? FREE.prodPins;

  const canToggle = isEditMode && (currentLocPins < totalLocPins || currentProdPins < totalProdPins);

  const isOnProPlan = (currentLocPins  > (PRO.locPins  + FREE.locPins)
                   || currentProdPins > (PRO.prodPins + FREE.prodPins));

  const headingLabel = isOnProPlan ? 'Your plan' : 'Pro plan';

  const locationColor = projectData?.location_color ?? '#26A3DB';
  const productColor  = projectData?.product_color  ?? '#F2C538';

  const baseLocCapacity  = FREE.locPins  + PRO.locPins;
  const baseProdCapacity = FREE.prodPins + PRO.prodPins;

  const locShortfall  = Math.max(0, currentLocPins  - baseLocCapacity);
  const prodShortfall = Math.max(0, currentProdPins - baseProdCapacity);

  const computeMinPacks = (pro) => {
    const baseLocCap  = FREE.locPins  + (pro ? PRO.locPins  : 0);
    const baseProdCap = FREE.prodPins + (pro ? PRO.prodPins : 0);
    const locShort    = Math.max(0, currentLocPins  - baseLocCap);
    const prodShort   = Math.max(0, currentProdPins - baseProdCap);
    const minLoc  = PACK.locPins  > 0 ? Math.ceil(locShort  / PACK.locPins)  : 0;
    const minProd = PACK.prodPins > 0 ? Math.ceil(prodShort / PACK.prodPins) : 0;
    return Math.max(minLoc, minProd);
  };

  const [packs,              setPacks]              = useState(Math.max(Number(planDetails.additional_count) || 0, computeMinPacks(true)));
  const [proSelected,        setProSelected]        = useState(true);
  const [initialPacks,       setInitialPacks]       = useState(Math.max(Number(planDetails.additional_count) || 0, computeMinPacks(true)));
  const [initialProSelected, setInitialProSelected] = useState(true);

  const effectivePro   = canToggle ? proSelected : true; 
  const minPacks       = effectivePro ? computeMinPacks(true) : 0;
  const packCardActive = packs > 0;

  useEffect(() => {
    setPacks((prev) => Math.max(prev, minPacks));
  }, [minPacks]);
 
  useEffect(() => {
    if (isOpen) {
      const existingPacks = Number(isOpen?.plan?.additional_count) || 0;
      const initPacks = Math.max(existingPacks, computeMinPacks(true));
      setPacks(initPacks);
      setProSelected(true);
      setInitialPacks(initPacks);
      setInitialProSelected(true);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handlePackChange = (next) => {
    setPacks(Math.max(minPacks, next));
  };
 
  const hasChanges = packs !== initialPacks || proSelected !== initialProSelected;
  const isOverLimit = currentLocPins > totalLocPins || currentProdPins > totalProdPins;
  const upgradeButtonDisabled = isEditMode && !hasChanges && !isOverLimit;

  const proRemoveBlocked = effectivePro && (packs > 0 || computeMinPacks(false) > 0);

  const handleTogglePro = () => {
    if (proSelected) {
      if (proRemoveBlocked) return;
      setProSelected(false);
    } else {
      setProSelected(true);
    }
  };

  const newLoc  = FREE.locPins  + (effectivePro ? PRO.locPins  : 0) + packs * PACK.locPins;
  const newProd = FREE.prodPins + (effectivePro ? PRO.prodPins : 0) + packs * PACK.prodPins;
  const total   = (effectivePro ? PRO.price : 0) + packs * PACK.price;

  const discount        = planDetails?.discount ?? 0;
  const discountAmt     = discount > 0 ? parseFloat(((total * discount) / 100).toFixed(2)) : 0;
  const discountedTotal = parseFloat((total - discountAmt).toFixed(2));

  const locOver  = currentLocPins  > totalLocPins;
  const prodOver = currentProdPins > totalProdPins;

  const proCardStyle = {
    ...cardStyle,
    marginBottom: 20,
    position: 'relative',
    border:     effectivePro ? '1px solid #d97706' : '1px solid #e0e0e0',
    background: effectivePro ? '#d9770617'         : '#f7f7f7',
    transition: 'border 0.15s, background 0.15s',
  };

  const packSectionStyle = {
    borderRadius: 10, padding: '14px 16px', marginBottom: 20,
    border:     packCardActive ? '1px solid #059669' : '1px solid #e0e0e0',
    background: packCardActive ? '#05966917'         : '#f7f7f7',
    transition: 'border 0.15s, background 0.15s',
  };

  const handleUpgradeClick = () => {
    const proLinePrice    = effectivePro ? PRO.price : 0;
    const packLinePrice   = PACK.price * packs;
    const subtotal        = proLinePrice + packLinePrice;
    const discAmt         = discount > 0 ? parseFloat(((subtotal * discount) / 100).toFixed(2)) : 0;
    const finalTotal      = parseFloat(subtotal.toFixed(2));
    const finalDiscounted = parseFloat((subtotal - discAmt).toFixed(2));

    onUpgradeAndPublish({
      planDetails:    isOpen,
      packs,
      isProSelected:  effectivePro,
      total:          finalTotal,
      packPrice:      PACK.price,
      proPrice:       PRO.price,
      discount,
      discountAmt:    discAmt,
      isOnProPlan,
      planName,
      discountedTotal: finalDiscounted,
      summary: packs > 0
        ? `${effectivePro ? planName + ' + ' : ''}Additional pack x${packs}`
        : (effectivePro ? planName : 'Free plan'),
      lineItems: [
        ...(effectivePro ? [{
          label:      planName,
          price:      proLinePrice,
          discounted: discount > 0 ? parseFloat(((proLinePrice * discount) / 100).toFixed(2)) : 0,
        }] : []),
        ...(packs > 0 ? [{
          label:      `Additional pack x${packs}`,
          price:      packLinePrice,
          discounted: discount > 0 ? parseFloat(((packLinePrice * discount) / 100).toFixed(2)) : 0,
        }] : []),
        ...(discount > 0 && subtotal > 0 ? [{
          label:      `Discount (${discount}%)`,
          price:      0,
          discounted: discAmt,
          isDiscount: true,
        }] : []),
      ],
    });
  };

  const formatBreakdown = (...values) => {
    const filtered = values.filter(v => v !== null && v !== undefined && v !== 0);
    if (filtered.length <= 1) return '';

    return `(${filtered.join(' + ')})`; 
  };

  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: '16px',
    }}>
      <div style={{
        background: '#fff', borderRadius: 16,
        width: '100%', maxWidth: 520, maxHeight: '90vh',
        display: 'flex', flexDirection: 'column', overflow: 'hidden',
      }}>

        <div style={{ padding: '24px 24px 16px', borderBottom: '1px solid #f0f0f0', flexShrink: 0 }}>
          <h2 style={{ textAlign: 'center', fontSize: 20, fontWeight: 600, margin: '0 0 6px' }}>
            {canToggle ? 'Manage your plan' : 'Publish your project'}
          </h2>
          <p style={{ textAlign: 'center', fontSize: 13, color: '#666', margin: 0 }}>
            {canToggle
              ? 'Adjust your plan before publishing.'
              : <>You'll need to{' '}<span style={{ color: '#ED0000', fontWeight: 500 }}>update your plan</span>{' '}to publish this project.</>
            }
          </p>
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>

          <SectionLabel>Your current usage</SectionLabel>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
            <UsageCard pin={locationIconSvg(locationColor)} label="Location pins" used={currentLocPins} limit={totalLocPins} color="#ED0000" over={locOver} />
            <UsageCard pin={productIconSvg(productColor)}  label="Product pins"  used={currentProdPins} limit={totalProdPins} color="#ED0000" over={prodOver} />
          </div>

          <SectionLabel>{headingLabel}</SectionLabel>
          <div style={proCardStyle}>

            {canToggle && (
              <button
                onClick={handleTogglePro}
                title={
                  !effectivePro
                    ? 'Add Pro plan'
                    : packs > 0
                    ? 'Remove upgrade packs first before removing Pro'
                    : computeMinPacks(false) > 0
                    ? 'Pro plan is required to cover your current pin usage'
                    : 'Remove Pro plan'
                }
                style={{
                  position: 'absolute', top: 8, right: 8,
                  width: 22, height: 22, borderRadius: '50%', padding: 0,
                  border:     effectivePro ? '1px solid #d97706' : '1px solid #bbb',
                  background: effectivePro ? '#d97706' : 'transparent',
                  color:      effectivePro ? '#fff' : '#888',
                  cursor:     proRemoveBlocked ? 'not-allowed' : 'pointer',
                  opacity:    proRemoveBlocked ? 0.4 : 1,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 14, lineHeight: 1,
                  transition: 'all 0.15s',
                }}
              >
                {effectivePro ? '✕' : '+'}
              </button>
            )}

            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              {proSvg}
              <div>
                <div style={{ fontWeight: 600, fontSize: 15 }}>{planName}</div>
                <div style={{ fontSize: 12, marginTop: 2, fontWeight: 500 }}>
                  {!isOnProPlan && (
                    <>
                      <div style={{ color: '#d97706', display: 'flex', alignItems: 'center', gap: 5 }}>
                        <CheckIcon color="#d97706" /> Adds +{PRO.locPins} location pins
                      </div>
                      <div style={{ color: '#d97706', display: 'flex', alignItems: 'center', gap: 5 }}>
                        <CheckIcon color="#d97706" /> Adds +{PRO.prodPins} product pins
                      </div>
                    </>
                  )}
                  {isOnProPlan && (
                    <span style={{ color: '#666' }}>
                      {FREE.locPins + PRO.locPins} location pins • {FREE.prodPins + PRO.prodPins} product pins
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div style={{ fontWeight: 600, fontSize: 15 }}>
              ${PRO.price}{' '}
              <span style={{ fontWeight: 400, fontSize: 12, color: '#666' }}>/ month</span>
            </div>
          </div>

          <SectionLabel>Adjust capacity</SectionLabel>
          <div style={packSectionStyle}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                {additionalSvg}
                <div>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>Upgrade pack</div>
                  <div style={{ fontSize: 12, color: '#666', marginTop: 2, fontWeight: 500 }}>
                    +{PACK.locPins} location pins • +{PACK.prodPins} product pins per pack
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: 8 }}>
                <span style={{ fontSize: 12, color: '#666', whiteSpace: 'nowrap' }}>
                  <span style={{ fontWeight: 600, fontSize: 15, color: '#000' }}>${PACK.price}</span>{' '}/ month each
                </span>
                <div style={{ opacity: !effectivePro ? 0.4 : 1, pointerEvents: !effectivePro ? 'none' : 'auto' }}>
                  <Counter value={packs} onChange={handlePackChange} minValue={minPacks} />
                </div>
              </div>
            </div>

            {packCardActive && (
              <>
                <div style={{ border: '1px solid #05966924', margin: '10px 0 0 52px' }} />
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 10 }}>
                  <div style={{ fontSize: 12, color: '#059669', display: 'flex', alignItems: 'center', gap: 5, fontWeight: 500 }}>
                    <CheckIcon /> Adds +{packs * PACK.locPins} location pins
                    {locShortfall > 0 && <span style={{ color: '#888', fontWeight: 400 }}>(you need {locShortfall} more)</span>}
                  </div>
                  <div style={{ fontSize: 12, color: '#059669', display: 'flex', alignItems: 'center', gap: 5, fontWeight: 500 }}>
                    <CheckIcon /> Adds +{packs * PACK.prodPins} product pins
                    {prodShortfall > 0 && <span style={{ color: '#888', fontWeight: 400 }}>(you need {prodShortfall} more)</span>}
                  </div>
                </div>
              </>
            )}
          </div>

          <SectionLabel>Your new capacity</SectionLabel>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
            <CapCard
              pin={locationIconSvg(locationColor)} label="Location pins" value={newLoc} color="#3182ce"
              // breakdown={`(${FREE.locPins}${effectivePro ? ` + ${PRO.locPins}` : ''}${packs * PACK.locPins > 0 ? ` + ${packs * PACK.locPins}` : ''})`}
              breakdown={formatBreakdown(
                FREE.locPins,
                effectivePro ? PRO.locPins : null,
                packs * PACK.locPins
              )}
            />
            <CapCard
              pin={productIconSvg(productColor)} label="Product pins" value={newProd} color="#d97706"
              // breakdown={`(${FREE.prodPins}${effectivePro ? ` + ${PRO.prodPins}` : ''}${packs * PACK.prodPins > 0 ? ` + ${packs * PACK.prodPins}` : ''})`}
              breakdown={formatBreakdown(
                FREE.prodPins,
                effectivePro ? PRO.prodPins : null,
                packs * PACK.prodPins
              )}
            />
          </div>

          <SectionLabel>Total</SectionLabel>
          <div style={{ ...cardStyle, marginBottom: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <IoPricetagOutline size={30} color="#059669" />
              <div>
                <div style={{ fontWeight: 600, fontSize: 15 }}>Total</div>
                <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>
                  {effectivePro ? headingLabel : 'Free plan'}
                  {packs > 0 ? ` + ${packs} upgrade pack${packs !== 1 ? 's' : ''}` : ''}
                </div>
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              {discount > 0 && total > 0 && (
                <div style={{ fontSize: 13, color: '#aaa', textDecoration: 'line-through' }}>
                  ${total} / month
                </div>
              )}
              <div style={{ fontSize: 22, fontWeight: 700 }}>
                {total === 0
                  ? 'Free'
                  : `$${discount > 0 ? discountedTotal : total}`
                }
                {total > 0 && <span style={{ fontSize: 13, fontWeight: 400, color: '#666' }}>{' '}/ month</span>}
              </div>
              {discount > 0 && total > 0 && (
                <div style={{ fontSize: 11, color: '#059669', fontWeight: 600, marginTop: 2 }}>
                  {discount}% discount applied
                </div>
              )}
              <div style={{ fontSize: 11, color: '#666', marginTop: 2 }}>Billed monthly. Cancel anytime.</div>
            </div>
          </div>

        </div>

        <div style={{ padding: '16px 24px 20px', borderTop: '1px solid #f0f0f0', flexShrink: 0, background: '#fff' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
            <button
              onClick={onContinueEditing}
              style={{ padding: '13px', borderRadius: 10, border: '1px solid #ddd', background: '#fff', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}
            >
              {cancelLabel}
            </button>
            <button
              onClick={upgradeButtonDisabled ? undefined : handleUpgradeClick}
              disabled={upgradeButtonDisabled}
              style={{
                padding: '13px', borderRadius: 10,
                border: 'none',
                background: upgradeButtonDisabled ? '#d1d5db' : '#f6a623',
                color: upgradeButtonDisabled ? '#9ca3af' : '#fff',
                fontSize: 14, fontWeight: 600,
                cursor: upgradeButtonDisabled ? 'not-allowed' : 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 7,
              }}
            >
              <LockIcon color={upgradeButtonDisabled ? '#9ca3af' : '#fff'} />
              {canToggle && !effectivePro && packs === 0 ? 'Publish' : 'Upgrade & publish'}
            </button>
          </div>
          <p style={{ textAlign: 'center', fontSize: 12, color: '#999', margin: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5 }}>
            <LockIcon size={12} color="#999" />
            Secure checkout. Your project will be published after payment.
          </p>
        </div>

      </div>
    </div>
  );
};
 
 


export {
    PublishUpgradeModal,
    ProPinModal,
    EmbedProjectModal,
    GenerateQrModal,
}